import './EducacionContinuaVirtual.css';

const promesas = [
  {
    titulo: 'Educación de Calidad',
    descripcion: 'Contenidos diseñados por expertos y actualizados regularmente para ofrecerte la mejor formación.',
    icono: '01',
  },
  {
    titulo: 'Certificación',
    descripcion: 'Obtén certificados reconocidos que validan tus habilidades y conocimientos adquiridos.',
    icono: '02',
  },
  {
    titulo: 'Disponibilidad',
    descripcion: 'Accede a tus cursos en cualquier momento y desde cualquier lugar, adaptándolos a tu ritmo de vida.',
    icono: '03',
  },
];

const EducacionContinuaVirtual = () => (
  <main className="oferta-academica-page virtual-page">
    <section className="virtual-hero" aria-labelledby="virtual-titulo">
      <div className="virtual-hero-copy">
        <p className="oferta-eyebrow">Oferta académica</p>
        <h1 id="virtual-titulo">Programas Virtuales</h1>
        <span className="oferta-accent" aria-hidden="true" />
        <p className="virtual-introduccion">
          Explora nuestros programas de educación virtual diseñados para brindarte la flexibilidad y calidad que necesitas. Inscríbete hoy y lleva tu aprendizaje al siguiente nivel desde la comodidad de tu hogar.
        </p>
        <a
          className="oferta-primary-button"
          href="https://www.crc.edu.co/"
          target="_blank"
          rel="noreferrer"
        >
          Conoce más e Inscríbete <span aria-hidden="true">↗</span>
        </a>
      </div>
      <div className="virtual-hero-visual" aria-hidden="true">
        <div className="virtual-visual-orbit virtual-visual-orbit-outer" />
        <div className="virtual-device">
          <div className="virtual-device-screen">
            <div className="virtual-screen-top"><i /><i /><i /></div>
            <div className="virtual-screen-body">
              <div className="virtual-screen-menu"><i /><i /><i /><i /></div>
              <div className="virtual-screen-panel">
                <span className="virtual-screen-heading" />
                <span className="virtual-screen-line virtual-screen-line-long" />
                <span className="virtual-screen-line" />
                <div className="virtual-screen-progress"><i /></div>
                <div className="virtual-screen-modules"><i /><i /><i /></div>
              </div>
            </div>
          </div>
          <div className="virtual-device-base" />
        </div>
        <div className="virtual-device-seal"><span>✓</span></div>
      </div>
    </section>

    <section className="virtual-promesa" aria-labelledby="virtual-promesa-titulo">
      <div className="oferta-section-heading">
        <p className="oferta-eyebrow">Educación continua</p>
        <h2 id="virtual-promesa-titulo">Nuestra Promesa de Calidad</h2>
        <span className="oferta-accent" aria-hidden="true" />
      </div>
      <div className="promesa-grid">
        {promesas.map((promesa) => (
          <article className="promesa-card" key={promesa.titulo}>
            <span className="promesa-numero" aria-hidden="true">{promesa.icono}</span>
            <h3>{promesa.titulo}</h3>
            <p>{promesa.descripcion}</p>
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default EducacionContinuaVirtual;
